
import React from 'react';
import { TableHead, TableHeader, TableRow } from '@/components/ui/table';

const VoltageRegulatorTableHeader: React.FC = () => {
  return (
    <TableHeader>
      <TableRow>
        <TableHead>Device ID</TableHead>
        <TableHead>Location</TableHead>
        <TableHead>Status</TableHead>
        <TableHead>Battery</TableHead>
        <TableHead>Signal</TableHead>
        <TableHead>Regulation</TableHead>
        <TableHead>Alerts</TableHead>
      </TableRow>
    </TableHeader>
  );
};

export default VoltageRegulatorTableHeader;
